import { render, staticRenderFns } from "./mezziDetail.vue?vue&type=template&id=50579bc3&"
import script from "./mezziDetail.vue.js?vue&type=script&lang=js&"
export * from "./mezziDetail.vue.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports